var Constants = {};

Constants.STATUS = {
  REG: 'REG',
  PRE: 'PRE',
  ACCL: 'ACCL',
  UCCL: 'UCCL',
  AABS: 'AABS',
  CALL: 'CALL',
  ABS: 'ABS',
  CCL: 'CCL',
  FIN: 'FIN',
  WIP: 'WIP',
};

Constants.STATUS_NAME = {
  REG: '登録済み',
  PRE: '事前呼出',
  ACCL: '取消(自動)',
  UCCL: '取消(お客様)',
  AABS: '不在(自動)',
  CALL: '呼出',
  ABS: '不在',
  CCL: '取消',
  WIP: '対応',
  FIN: '完了',
};

Constants.data1 = {
  0: '①国内　お申込み・ご相談  ',
  1: '②お受け取り  ',
  2: '③取消・その他  ',
};

Constants.PAPER_ORDER = 'PAPER_ORDER';

Constants.TIME_NAME = {
  RECEIPT_START: 'receipt_date_start',
  RECEIPT_END: 'receipt_date_end',

};

Constants.METHOD = {
};

Constants.METHOD_NAME = {
};

Constants.CLASS_NAME = {
  COUNTER: '窓口',
  OTHER: '管理者',
  UNKNOWN: '未定',
}

Constants.ON_EDIT = 1;
Constants.OFF_EDIT = 2;

Constants.DISP_FLAG = {
  DISP_OFF: '0',
  DISP_ON: '1',
};

Constants.CLASS_CHOICES = {
  TYPE: 'data1',
  IN_TYPE: 'radio',
  PARAM: 'kind',
}

Constants.CLASS = {
  COUNTER: '1',
  OTHER: '2',
  CHECK: '3',
};


Constants.PAYMENT = {

};

Constants.PAYMENT_NAME = {
};

Constants.CHANNEL = {
};

Constants.HEADING = {
  ADULT_NAME: '大人・子供',
  CHILD_NAME: '未就学児',
  COUNTER_NAME: 'カウンター・席',
  ADULT_SHORT: '大小',
  CHILD_SHORT: '未',
  COUNTER_SHORT: 'カウンター',
}

Constants.COUNTER = {
  SUBSCRIPTION: '1',
  RECEIVE: '2',
  CANCEL: '3'
};

Constants.COUNTER_NAME = {
  '1': '国内　お申込み・ご相談',
  '2': '国内　お受け取り',
  '3': '国内　取消・その他',
  SUBSCRIPTION: '国内　お申込み・ご相談',
  RECEIVE: '国内　お受け取り',
  CANCEL: '国内　取消・その他',
};

Constants.COLUMN = {
  ADULT: 'data1',
  CHILD: 'data2',
  COUNTER: 'data3',
};

Constants.COLUMN = {
  kind: 'data1'
};

// 旧バージョン
// Constants.COLUMN = {
//   ADULT: 'data1',
//   CHILD: 'data2',
//   COUNTER: 'data3',
// };

Constants.SAIBAN_CLASS = {
  RECEIPT: 'RECEIPT',
};

Constants.RECEIPT_NUM = {
};

Constants.SHOP_ID = 1;
Constants.USER_CLASS = 1;

Constants.REQUEST = "request";
Constants.CANCEL = "cancel";

Constants.SETTING = {
  INTERVAL_ABS: "INTERVAL_ABS",
  INTERVAL_CCL: "INTERVAL_CCL",
  INTERVAL_BATCH: "INTERVAL_BATCH",
  CAL_DISP_HOLIDAY_START: "CAL_DISP_HOLIDAY_START",
  CAL_DISP_HOLIDAY_END: "CAL_DISP_HOLIDAY_END",
  CAL_LINE_HOLIDAY_START: "CAL_LINE_HOLIDAY_START",
  CAL_LINE_HOLIDAY_END: "CAL_LINE_HOLIDAY_END",
  CAL_DISP_DEFAULT_START: "CAL_DISP_DEFAULT_START",
  CAL_DISP_DEFAULT_END: "CAL_DISP_DEFAULT_END",
  CAL_LINE_DEFAULT_START: "CAL_LINE_DEFAULT_START",
  CAL_LINE_DEFAULT_END: "CAL_LINE_DEFAULT_END",
  OPEN_DISP_FLG: "OPEN_DISP_FLG",
  OPEN_LINE_FLG: "OPEN_LINE_FLG",
  OPEN_WAIT_FLG: "OPEN_WAIT_FLG",
  OPERATE_DATE: "OPERATE_DATE",
  AUTOPRE_COUNT: "AUTOPRE_COUNT",
  DEFAULT_WAIT_FLG: "DEFAULT_WAIT_FLG",
  NOTIFY_USE_FLG: "NOTIFY_USE_FLG",
  VOICE_USE_FLG: "VOICE_USE_FLG",
  VOICE_RATE: "VOICE_RATE",
  VOICE_PITCH: "VOICE_PITCH",
}

Constants.OPEN = "1";
Constants.CLOSE = "2";

Constants.ACTIVE_BUTTONS = {
  'REG': [
    'PRE',
  ],
  'PRE': [
    'CALL',
  ],
  'ABS': [
    'FIN'
  ],
  'AABS': [
    'FIN'
  ],
  'CALL': [
    'HOLD',
    'WIP',
  ],
  'WIP': [
    'FIN',
  ],
  'CCL': [],
  'UCCL': [],
  'ACCL': [],
  'FIN': [],
};

Constants.COLOR = {
  1: 'info',
  2: 'success',
  BUS: 'info',
  TRAIN: 'success',
};

Constants.MAX_CALL = 6;
Constants.MAX_ABS = 10;
Constants.MAX_PRE = 4;

export default Constants;